import React, {
  memo, useCallback, useState, useEffect,
} from 'react';

import { Button, TextField } from '@mui/material';

import { toast } from 'react-toastify';
import Grid24 from '../../../../components/UI/Grid24';
import useStyle from '../AcordosStyle';

import { dialogAlterarParcelaCartaoController } from './dialogAlterarParcelaCartao';

import { extractResponseErrorMessage, getFieldName } from '../../../../helpers';
import { loadingInspecaoProcessoController } from '../../loadingInspecaoProcessoController';


function DialogAlterarCartao({
  setOpenDialogAlterarCartao,
  dadosParcelaCartao,
  idProcesso,
  nroParcela,
  idAcordo,
  idAcordoParcela,
  tipoFormPgtp,
  setLoadings,
  updatePage,
}) {
  const style = useStyle();

  const [formFields, setFormFields] = useState(dialogAlterarParcelaCartaoController.makeFormFields(dadosParcelaCartao));


  const onChangeHandler = useCallback((e) => {
    const name = getFieldName(e.target);
    const { value } = e.target;
    setFormFields(oldValue => ({ ...oldValue, [name]: { ...oldValue[name], value } }));
  }, []);

  async function onClickSubmitParcela(e) {
    e.preventDefault();
    setLoadings(loadingInspecaoProcessoController.changeLoadingAcordos(true));
    try {
      await dialogAlterarParcelaCartaoController.salvar(idProcesso,
        nroParcela,
        idAcordo,
        idAcordoParcela,
        tipoFormPgtp, formFields);
      setOpenDialogAlterarCartao(false);
      updatePage();
      setOpenDialogAlterarCartao(false);
    } catch (error) {
      const erroMessage = extractResponseErrorMessage(error);
      if (erroMessage !== 'Erro não mapeado') {
        toast.error(erroMessage);
      }
    } finally {
      setLoadings(loadingInspecaoProcessoController.changeLoadingAcordos(false));
    }
  }

  useEffect(() => {
    setFormFields(dialogAlterarParcelaCartaoController.makeFormFields(dadosParcelaCartao));
  }, [dadosParcelaCartao]);


  return (
    <>
      <Grid24 container isFormContainer spacing="1">
        <Grid24 item xs={24} sm={24}>
          <Grid24 item xs={24} sm={24} className={style.dialogAlterarParcelaDinheiro}>
            <div style={{ display: 'grid', marginTop: '9px' }}>
              <TextField
                name={formFields.observacaoCartao.name}
                defaultValue={formFields.observacaoCartao.value}
                onChange={onChangeHandler}
                multiline
                rows={4}
                id="outlined-multiline-static"
                label="Observações"
              />
            </div>
          </Grid24>
        </Grid24>
      </Grid24>
      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <Button
          onClick={() => setOpenDialogAlterarCartao(false)}
        >
          Cancelar
        </Button>
        <Button onClick={onClickSubmitParcela}>
          Confirmar
        </Button>
      </div>

    </>
  );
}
export default memo(DialogAlterarCartao);
